export enum Country {
  GERMANY = 'DE',
}
export enum Gender {
  MALE = 'Männlich',
  FEMALE = 'Weiblich',
  DIVERS = 'Divers',
  UNKNOWN = 'Unbestimmt',
}
export enum Familienstand {
  SINGLE = 'Ledig',
  VERHEIRATET = 'Verheiratet',
  GESCHIEDEN = 'Geschieden',
  VERWITWET = 'Verwitwet',
  GETRENNT = 'Getrennt',
  VERPARTNERT = 'Verpartnert',
  ENTPARTNERT = 'Entpartnert',
}
export enum BeschaeftigungsTyp {
  MAIN = 'Hauptarbeitgeber',
  SECOND = 'Nebenarbeitgeber',
}

export enum Konfession {
  NICHT_KIRCHENSTEUERPFLICHTIG = 'Nicht Kirchensteuerpflichtig',
  EVANGELISCH = 'Evangelisch',
  ROEMISCH_KATHOLISCH = 'Römisch-katholisch',
  ALT_KATHOLISCH = 'Alt-katholisch',
  EVANGELISCH_LUTHERISCH = 'Evangelisch lutherisch',
  EVANGELISCH_REFORMIERT = 'Evangelisch reformiert',
  FREIE_RELIGIONSGEMEINSCHAFT_ALZEY = 'Freie Religionsgemeinschaft Alzey',
  FREIRELIGIOESE_LANDESGEMEINDE_BADEN = 'Freireligiöse Landesgemeinde Baden',
  FREIRELIGIOESE_LANDESGEMEINDE_PFALZ = 'Freireligiöse Landesgemeinde Pfalz',
  FREIRELIGIOESE_GEMEINDE_MAINZ = 'Freireligiöse Gemeinde Mainz',
  FRANZOESISCH_REFORMIERT = 'Französisch reformiert',
  FREIRELIGIOESE_GEMEINDE_OFFENBACH_MAIN = 'Freireligiöse Gemeinde Offenbach/Main',
  ISRAELITISCHE_RELIGIONSGEMEINSCHAFT_BADEN = 'Israelitische Religionsgemeinschaft Baden',
  ISRAELITISCHE_KULTUSSTEUER_DER_KULTUSBERECHTIGTEN_GEMEINDEN = 'Israelitische Kultussteuer der kultusberechtigten Gemeinden',
  ISRAELITISCHE_KULTUSSTEUER_FRANKFURT = 'Israelitische Kultussteuer Frankfurt',
  ISRAELITISCHE_RELIGIONSGEMEINSCHAFT_WUERTTEMBERGS = 'Israelitische Religionsgemeinschaft Württembergs',
  JUEDISCHE_KULTUSSTEUER = 'Jüdische Kultussteuer',
  SONSTIGE = 'Sonstige',
}

/**
 * Religionszugehörigkeit of students and guardians, the edoo.sys value list (WL 1037) one to one. Konfession is the
 * church tax list of employees for LODAS.
 */
export enum Religion {
  ROEMISCH_KATHOLISCH = 'Römisch-katholisch',
  EVANGELISCH = 'Evangelisch',
  JUEDISCH = 'Jüdisch',
  ISLAMISCH = 'Islamisch',
  ALEVITISCH = 'Alevitisch',
  MENNONITISCH = 'Mennonitisch',
  FREIRELIGIOES = 'Freireligiös',
  SONSTIGE = 'Sonstige Religionsgemeinschaft',
  KEINE = 'Keine Religionsgemeinschaft',
}

export enum NamensTitel {
  DR = 'Dr.',
  DRDR = 'Dr. Dr.',
  PROF = 'Prof.',
  PROFDR = 'Prof. Dr.',
  PROFDRDR = 'Prof. Dr. Dr.',
}

export enum SchwerbehinderungsGrad {
  B20 = '20',
  B30 = '30',
  B30G = '30 mit Gleichstellung',
  B40 = '40',
  B40G = '40 mit Gleichstellung',
  B50 = '50',
  B60 = '60',
  B70 = '70',
  B80 = '80',
  B90 = '90',
  B100 = '100',
}

export enum GermanTaxClassification {
  C1 = '1',
  C2 = '2',
  C3 = '3',
  C4 = '4',
  C5 = '5',
  C6 = '6',
}

export enum GermanInsuranceTypes {
  DEFAULT = 'pflichtversichert',
  VOLUNTARY = 'freiwillig versichert',
  PRIVAT = 'privat versichert',
  FAMILY = 'familienversichert',
}

export enum GermanInsuranceCompanies {
  A = 'a',
}

export enum Bundesland {
  BADEN_WÜRTTEMBERG = 'Baden-Württemberg',
  BAYERN = 'Bayern',
  BERLIN_EHEM_OST_BERLIN = 'Berlin (ehem. Ost-Berlin)',
  BERLIN_EHEM_WEST_BERLIN = 'Berlin (ehem. West-Berlin)',
  BRANDENBURG = 'Brandenburg',
  BREMEN = 'Bremen',
  BREMERHAVEN = 'Bremerhaven',
  HAMBURG = 'Hamburg',
  HESSEN = 'Hessen',
  MECKLENBURG_VORPOMMERN = 'Mecklenburg-Vorpommern',
  NIEDERSACHSEN = 'Niedersachsen',
  NORDRHEIN_WESTFALEN = 'Nordrhein-Westfalen',
  RHEINLAND_PFALZ = 'Rheinland-Pfalz',
  SAARLAND = 'Saarland',
  SACHSEN = 'Sachsen',
  SACHSEN_ANHALT = 'Sachsen-Anhalt',
  SCHLESWIG_HOLSTEIN = 'Schleswig-Holstein',
  THÜRINGEN = 'Thüringen',
}

export enum Anstellungsform {
  ANGESTELLTER = 'Angestellte:r',
  ANGESTELLTER_ALTERSVOLLRENTNER = 'Angestellte:r Altersvollrentner:in',
  AUSZUBILDENDER = 'Auszubildende:r',
  GERINGFÜGIG_BESCHÄFTIGTER_MINIJOB = 'geringfügig Beschäftigte:r (MiniJob)',
  KURZFRISTIG_BESCHÄFTIGTER = 'Kurzfristig Beschäftigte:r',
  PRAKTIKANT_PFLICHTPRAKTIKUM = 'Praktikant:in (Pflichtpraktikum)',
  PRAKTIKANT_FREIWILLIGES_PRAKTIKUM = 'Praktikant:in (freiwilliges Praktikum)',
  PRAKTIKANT_VOR_ODER_NACHPRAKTIKUM = 'Praktikant:in (Vor- oder Nachpraktikum)',
  WERKSTUDENT = 'Werkstudent:in',
  GESCHÄFTSFÜHRER = 'Geschäftsführer:in',
  VORSTANDSMITGLIED = 'Vorstandsmitglied',
  UNSTÄNDIG_BESCHÄFTIGTER_NICHT_BERUFSMÄSSIG = 'unständig Beschäftigte:r (nicht berufsmäßig)',
  UNSTÄNDIG_BESCHÄFTIGTER_BERUFSMÄSSIG = 'unständig Beschäftigte:r (berufsmäßig)',
  FREIWILLIGES_JAHR_BUNDESFREIWILLIGENDIENST = 'Freiwilliges Jahr / Bundesfreiwilligendienst',
}

export enum PauschalbesteuerungMiniJob {
  INDIVIDUELL = 'Individuell nach Steuerklasse',
  AG_ZAHLT = 'MiniJob 2% zahlt AG',
  AN_ZAHLT = 'MiniJob 2% zahlt AN',
}

export enum PauschalbesteuerungGeringfuegig {
  SCHULER = 'Schüler(in)',
  STUDENT = 'Student(in)',
  SCHULENTLASSENER_BERUFSABSICHT = 'Schulentlassene(r) mit Berufsausbildungsabsicht',
  SCHULENTLASSENER_STUDIENABSICHT = 'Schulentlassene(r) mit Studienabsicht',
  SCHULENTLASSENER_FREIWILLIGENDIENST = 'Schulentlassene(r) mit Freiwilligendienstabsicht',
  ARBEITSLOSE = 'Beschäftigungsloser Arbeit-/Ausbildungsuchende(r)',
  FREIWILLIGENDIENST = 'Freiwilligendienstleistender',
  PRAKTIKANT = 'Praktikant(in)',
  BEAMTE = 'Beamtin/Beamter',
  SELBSTSTAENDIGE = 'Selbstständige(r)',
  ARBEITNEHMER_SOZIALVERSICHERUNG = 'Arbeitnehmer(in) mit sozialversicherungspflichtiger Hauptbeschäftigung',
  URLAUB = 'Arbeitnehmer(in) im unbezahlten Urlaub aufgrund der Hauptbeschäftigung',
  ELTERNZEIT = 'Arbeitnehmer(in) in der Elternzeit aufgrund der Hauptbeschäftigung',
  ALTERSVOLLRENTNER_VOR = 'Altersvollrentner vor Erreichen der Regelaltersgrenze',
  ALTERSVOLLRENTNER_NACH = 'Altersvollrentner nach Erreichen der Regelaltersgrenze',
  VERSORGUNGSEMPFANGER = 'Versorgungsempfänger nach Erreichen einer Altersgrenze',
  SONSTIGE = 'Sonstige',
}

export enum Probezeit {
  KEINE = 'Keine Probezeit',
  HALBJAHR = '6 Monate',
}

export enum AbwesenheitType {
  URLAUB = 'Urlaub',
  KRANKHEIT = 'Krankheit',
}

export enum DialogResult {
  OK,
  CANCEL,
  DELETE,
}

export enum MitarbeiterTab {
  DETAILS = 'Details',
  VERTRAEGE = 'Verträge',
  VERLAUF = 'Verlauf',
  VORGESETZTE = 'Vorgesetzte',
  TICKET = 'Ticket',
  BESCHAEFTIGUNGSGENEHMMIGUNG = 'Beschäftigungsgenehmigungen',
  SORGEBERECHTIGUNG = 'Sorgeberechtigung',
  ABWESENHEITEN = 'Abwesenheiten',
}

export enum PersonTab {
  PROFIL = 'Profil',
  MITARBEITER = 'Mitarbeiter',
  SCHUELER = 'Schüler',
  IHRE_KINDER = 'Ihre Kinder',
  RECHTEVERWALTUNG = 'Rechteverwaltung',
  BUCHUNGEN = 'Buchungen',
  ABWESENHEITEN = 'Abwesenheiten',
  VERLAUF = 'Verlauf',
  SPENDE = 'Spende',
  QUITTUNGEN = 'Quittungen',
  MICROSOFT = 'Microsoft',
}

export enum SchuleKostenstelle {
  ZENTRALE = '499',
  SAMMELBECKEN = '1',
  THERESIANUM_MAINZ = '432',
  WILLIGIS_GYMNASIUM_MAINZ = '433',
  ALBERTUS_MAGNUS_VIERNHEIM = '435',
  SANKT_LIOBA_SCHULE_BAD_NAUHEIM = '437',
  MARIENSCHULE_OFFENBACH = '438',
  SANKT_MARIEN_SCHULE_ALZEY = '451',
  MARTINUS_SCHULE_OBERSTADT_MAINZ = '453',
  MARTINUS_SCHULE_MAINZ_WEISENAU = '454',
  MARTINUS_SCHULE_WEISSLILIENGASSE_MAINZ = '455',
  WILLIGIS_REALSCHULE_MAINZ = '461',
  HILDEGARIDSSCHULE_BINGEN = '471',
  KATHOLISCHE_BERUFSBILDENDE_SCHULE_MAINZ = '474',
}

export enum ZahlungsRythmus {
  MONATLICH = 'Monatlich',
  JAEHRLICH = 'Jährlich',
}

export enum ArtKrankenVersicherung {
  EIGENE_MITGLIEDSCHAFT = 'Eigene Mitgliedschaft',
  FAMILIENVERSICHERUNG = 'Familienversicherung',
}
